export var ADDRESS_TARGETS = /*#__PURE__*/ function(ADDRESS_TARGETS) {
    ADDRESS_TARGETS["COUNTRY"] = "country";
    ADDRESS_TARGETS["SUBDIVISION"] = "subdivision";
    ADDRESS_TARGETS["CITY"] = "city";
    ADDRESS_TARGETS["ADDRESS_LINE"] = "addressLine";
    ADDRESS_TARGETS["ADDRESS_LINE_2"] = "addressLine2";
    ADDRESS_TARGETS["POSTAL_CODE"] = "postalCode";
    ADDRESS_TARGETS["STREET_NAME"] = "streetName";
    ADDRESS_TARGETS["STREET_NUMBER"] = "streetNumber";
    ADDRESS_TARGETS["APARTMENT"] = "apartment";
    return ADDRESS_TARGETS;
}({});
export function fromAtlasAddress(address, isMultilineAddressField) {
    const { country, subdivision, city, addressLine, streetAddress, addressLine2, postalCode } = address;
    const partial = {};
    if (isMultilineAddressField) {
        if (country) {
            partial.country = country;
        }
        if (subdivision) {
            partial.subdivision = subdivision;
        }
        if (city) {
            partial.city = city;
        }
        if (addressLine) {
            partial.addressLine = addressLine;
        } else if (streetAddress?.formattedAddressLine) {
            partial.addressLine = streetAddress?.formattedAddressLine;
        }
        if (addressLine2) {
            partial.addressLine = addressLine2;
        }
        if (postalCode) {
            partial.postalCode = postalCode;
        }
        if (streetAddress?.apt) {
            partial.apartment = streetAddress?.apt;
        }
        if (streetAddress?.name) {
            partial.streetName = streetAddress?.name;
        }
        if (streetAddress?.number) {
            partial.streetNumber = streetAddress.number;
        }
    } else {
        if (country) {
            partial.country = country;
        }
        if (subdivision) {
            partial.subdivision = subdivision;
        }
        if (city) {
            partial.city = city;
        }
        if (addressLine) {
            partial.address_line = addressLine;
        } else if (streetAddress?.formattedAddressLine) {
            partial.address_line = streetAddress?.formattedAddressLine;
        }
        if (addressLine2) {
            partial.address_line = addressLine2;
        }
        if (postalCode) {
            partial.postal_code = postalCode;
        }
        if (streetAddress?.apt) {
            partial.apartment = streetAddress?.apt;
        }
        if (streetAddress?.name) {
            partial.street_name = streetAddress?.name;
        }
        if (streetAddress?.number) {
            partial.street_number = streetAddress.number;
        }
    }
    return partial;
}

//# sourceMappingURL=address.js.map